// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'move-left-solid';

export const Component = () => (
  <path d='M20.657 3.044s.02-.044.046-.044h1.751c.026 0 .046.02.046.044v18.912c0 .025-.02.044-.046.044h-1.751a.045.045 0 0 1-.046-.044V3.044Zm-11.9 13.3c.237.152.348.4.348.687 0 .546-.364.896-.932.896a.931.931 0 0 1-.654-.265l-4.741-4.517-.09-.119c-.147-.284-.188-.374-.188-.512 0-.157.062-.314.188-.557l.09-.119 4.74-4.515a.929.929 0 0 1 .654-.266c.567 0 .932.35.932.896 0 .302-.093.554-.334.686l-3.05 2.935h11.893c.578 0 .932.374.932.94 0 .545-.365.896-.932.896H5.718l3.038 2.934Z' />
);

export const viewBox = '0 0 25 25';
